export const tours = Object.freeze({
  'company-form': {
    scope: 'user',
    steps: [
      {
        target: 'details',
        title: 'Datos de tu negocio',
        text: 'El nombre es como te verán tus clientes. El email es obligatorio; teléfono y dirección los puedes dejar para después. El país ajusta la lada del teléfono.'
      },
      {
        target: 'business-type',
        title: 'Tipo de negocio',
        text: 'La elección más importante: adapta la app a tu giro y define si trabajas con citas. Si no está en la lista, escribe el tuyo.'
      },
      {
        target: 'save',
        title: 'Crear empresa',
        text: 'Cuando termines, toca aquí. Después sigues con tus servicios, clientes y horarios.'
      }
    ]
  },

  'appointment-form': {
    scope: 'company',
    steps: [
      {
        target: 'client',
        title: 'El cliente',
        text: 'Busca a alguien que ya tengas o escribe un nombre nuevo. Si es nuevo, se registra solo al guardar, con su teléfono.'
      },
      {
        target: 'service',
        title: 'El servicio',
        text: 'Define cuánto dura la cita y su precio. Solo aparecen tus servicios activos.'
      },
      {
        target: 'date',
        title: 'El día',
        text: 'Elige una fecha. Los días sin horario configurado aparecen deshabilitados.'
      },
      {
        target: 'hour',
        waitFor: 'date',
        title: 'La hora',
        text: 'Toca un horario libre.',
        waitText: 'Elige primero un día y aquí aparecerán los horarios libres.'
      },
      {
        target: 'worker',
        waitFor: 'date',
        title: 'Quién atiende',
        text: 'Elige al profesional o déjalo sin asignar. Si solo hay uno libre a esa hora, queda asignado solo.',
        waitText: 'Elige primero un día y una hora para ver quién está libre.'
      },
      {
        target: 'save',
        title: 'Guardar',
        text: 'Revisa y guarda. Si cierras antes, lo que llenaste queda como borrador por un par de horas.'
      }
    ]
  },

  'client-form': {
    scope: 'company',
    steps: [
      {
        target: 'name',
        title: 'Nombre completo',
        text: 'Así aparecerá en sus citas, en las búsquedas y en su expediente.'
      },
      {
        target: 'phone',
        title: 'Teléfono',
        text: 'Es obligatorio. Con él se reconoce al cliente cuando vuelve a reservar, para no duplicarlo.'
      },
      {
        target: 'email',
        title: 'Email',
        text: 'Opcional. Sirve para las comunicaciones por correo que actives.'
      },
      {
        target: 'notes',
        title: 'Notas',
        text: 'Preferencias, alergias o cualquier dato útil para atenderlo mejor.'
      },
      {
        target: 'save',
        title: 'Agregar cliente',
        text: 'Listo. Desde la lista de clientes podrás ver su historial y su expediente.'
      }
    ]
  },

  'service-form': {
    scope: 'company',
    steps: [
      {
        target: 'name',
        title: 'Nombre del servicio',
        text: 'Como lo verán tus clientes al reservar. Mejor «Corte + barba» que «Servicio 1».'
      },
      {
        target: 'duration',
        optional: true,
        title: 'Duración',
        text: 'Cuánto tiempo ocupa cada cita de este servicio. Define qué horarios quedan libres después.'
      },
      {
        target: 'price',
        title: 'Precio',
        text: 'El precio base, en números enteros. Es el que se usa en la cita y en tus ingresos.'
      },
      {
        target: 'attention',
        title: 'Cómo se atiende',
        text: '«Con cita previa» lo muestra para agendar en tu calendario. «Sin cita» es para atender y cobrar al momento. Puedes marcar las dos.'
      },
      {
        target: 'advanced',
        title: 'Opciones avanzadas',
        text: 'Tipo de precio, estado inicial de las órdenes y si requiere trabajador. Si no las necesitas, déjalas como están.'
      },
      {
        target: 'save',
        title: 'Agregar servicio',
        text: 'Guárdalo y ya podrás usarlo al crear citas.'
      }
    ]
  }
})

export const COMPANY_TOUR_KEYS = Object.freeze(
  Object.keys(tours).filter((key) => tours[key].scope === 'company')
)
